import { isValidElement, ReactNode } from 'react';
import { isFragment } from 'react-is';

export const isAvatarComponent = (element: ReactNode) => {
  if (import.meta.env.DEV) {
    if (isFragment(element)) {
      console.warn(
        "[AvatarStack]: The Avatar Stack component doesn't accept a Fragment as a child. Consider providing an array instead."
      );

      return false;
    }
  }

  return isValidElement(element);
};
